import { ICategory } from "../../models/categories/Category";
import { ITopic } from "../../models/topics/Topic";
import { IImageLink } from "../../models/digitalMedia/ImageLink";
import { IUser } from "../../models/users/User";
import { ITopicViewModel } from ".";


export class TopicViewModel implements ITopicViewModel {

  /**
   * @method Constructor method
   * @param {ITopic} topic A reference to the underlying Topic object
   * @param {IImageLink | undefined} profileImage If defined, a reference to an associated IImageLink (the Topic Profile image)
   */
  constructor(
    topic: ITopic,
    profileImage?: IImageLink
  ) {

    // assign properties from ctor parameters
    this._topic = topic;
    this._profileImage = profileImage;
  }


  /*-----------------------------------------------*/
  /**
   * @property {ITopic} _topic A reference to the underlying Topic object
   */
  private _topic: ITopic;

  /**
   * @method topic Getter method for _topic
   */
  get topic(): ITopic {
    return this._topic;
  }

  /**
   * @method topic Setter method for _topic
   * @param {ITopic} value The input value for setting _topic
   */
  set topic(value: ITopic) {
    this._topic = value;
  }
  /*-----------------------------------------------*/

  /*-----------------------------------------------*/
  /**
   * @property {IImageLink | undefined} _profileImage If defined, a reference to an associated IImageLink (the Topic Profile image)
   */
  private _profileImage: IImageLink | undefined = undefined;

  /**
   * @method profileImage Getter method for _profileImage
   */
  get profileImage(): IImageLink | undefined {
    return this._profileImage;
  }

  /**
   * @method profileImage Setter method for _profileImage
   * @param {IImageLink | undefined} value The input value for setting _profileImage
   */
  set profileImage(value: IImageLink | undefined) {
    this._profileImage = value;
  }
  /*-----------------------------------------------*/

}